export default "__VITE_ASSET__ATW1lagy__"